import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ILayoutConfig } from '../interfaces/layout-config';

@Injectable({
  providedIn: 'root'
})
export class LayoutConfigService {

  public layoutChange: Subject<ILayoutConfig>;

  constructor() {
    this.layoutChange = new Subject<ILayoutConfig>();
  }

  /**
   * Function to set the new layout config
   * @param config Layout config
   */
  public setConfig(config: ILayoutConfig, completeData?: boolean): void {
    this.layoutChange.next(config);
  }
}
